/* Baby Joe Joe, design-system UI behaviours for Shopify.
   Header state, menu drawer, search, accordions, quantity steppers,
   toast, shop filters and the stage finder. Plain JS, no dependencies. */
(function () {
  if (window.__bjjUI) return;
  window.__bjjUI = true;

  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }

  /* ---------------- Header: bare over hero, solid after scroll --------------- */
  function headerState() {
    $$('.site-header').forEach(function (h) {
      if (!h.classList.contains('site-header--overlay')) {
        h.classList.remove('is-bare');
        h.classList.add('is-solid');
        return;
      }
      var bare = window.scrollY <= 90;
      h.classList.toggle('is-bare', bare);
      h.classList.toggle('is-solid', !bare);
      var mark = $('.brand-mark img', h);
      if (mark) {
        var next = bare ? mark.getAttribute('data-src-bare') : mark.getAttribute('data-src-solid');
        if (next && mark.getAttribute('src') !== next) mark.setAttribute('src', next);
      }
    });
  }
  window.addEventListener('scroll', headerState, { passive: true });

  /* ---------------- Menu drawer --------------------------------------------- */
  function openDrawer() {
    var dr = $('.drawer'), sc = $('.drawer-scrim');
    if (!dr) return;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    if (sc) sc.classList.add('is-open');
    d.documentElement.style.overflow = 'hidden';
    $$('.drawer__nav a', dr).forEach(function (a, i) { a.style.transitionDelay = (90 + i * 45) + 'ms'; });
  }
  function closeDrawer() {
    var dr = $('.drawer'), sc = $('.drawer-scrim');
    if (!dr) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    if (sc) sc.classList.remove('is-open');
    d.documentElement.style.overflow = '';
    $$('.drawer__nav a', dr).forEach(function (a) { a.style.transitionDelay = '0ms'; });
  }

  /* ---------------- Search sheet -------------------------------------------- */
  function toggleSearch(force) {
    var s = $('[data-bjj-search]');
    if (!s) return;
    var open = force === undefined ? s.hasAttribute('hidden') : force;
    if (open) {
      s.removeAttribute('hidden');
      var i = $('input[type="search"], input[name="q"]', s);
      if (i) setTimeout(function () { i.focus(); }, 30);
    } else {
      s.setAttribute('hidden', '');
    }
  }

  /* ---------------- Toast ---------------------------------------------------- */
  var toastTimer;
  window.bjjToast = function (msg) {
    var t = $('#bjj-toast');
    if (!t) {
      t = d.createElement('div');
      t.id = 'bjj-toast';
      t.className = 'toast';
      t.innerHTML = '<span></span>';
      d.body.appendChild(t);
    }
    $('span', t).textContent = msg || 'Added to your bag';
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  };

  /* ---------------- Delegated clicks ---------------------------------------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bjj-menu-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-bjj-menu-close]') || t.closest('.drawer-scrim')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-bjj-search-toggle]')) { e.preventDefault(); toggleSearch(); return; }
    if (t.closest('[data-bjj-search-close]')) { e.preventDefault(); toggleSearch(false); return; }

    var head = t.closest('.acc__head');
    if (head) {
      e.preventDefault();
      var item = head.closest('.acc__item');
      var wasOpen = item.classList.contains('open');
      if (head.hasAttribute('data-bjj-acc-exclusive')) {
        $$('.acc__item', item.parentElement).forEach(function (i) { i.classList.remove('open'); });
      }
      item.classList.toggle('open', !wasOpen);
      head.setAttribute('aria-expanded', String(!wasOpen));
      var body = $('.acc__body', item);
      if (body) body.style.maxHeight = !wasOpen ? (body.scrollHeight + 40) + 'px' : '';
      return;
    }

    var step = t.closest('[data-bjj-qty]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = $('input', wrap);
      var out = $('span[data-qty-value]', wrap);
      var dir = step.getAttribute('data-bjj-qty') === 'up' ? 1 : -1;
      var min = parseInt(input && input.min, 10) || 1;
      var v = Math.max(min, (parseInt(input ? input.value : (out ? out.textContent : '1'), 10) || 1) + dir);
      if (input) input.value = v;
      if (out) out.textContent = v;
      return;
    }

    var sw = t.closest('[data-bjj-swatch]');
    if (sw) {
      $$('[data-bjj-swatch]', sw.parentElement).forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      return;
    }

    var th = t.closest('[data-bjj-thumb]');
    if (th) {
      e.preventDefault();
      var gal = th.closest('[data-bjj-gallery]');
      $$('[data-bjj-thumb]', gal).forEach(function (x) { x.classList.remove('active'); });
      th.classList.add('active');
      var main = $('[data-bjj-gallery-main] img', gal);
      var src = th.getAttribute('data-src');
      if (main && src) { main.setAttribute('src', src); main.removeAttribute('srcset'); }
      return;
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); toggleSearch(false); }
  });

  /* ---------------- Shop filters (client side, no reload) ------------------- */
  function applyFilters(root) {
    var cat = root.getAttribute('data-cat') || 'all';
    var stage = root.getAttribute('data-stage') || 'any';
    var sort = root.getAttribute('data-sort') || 'featured';
    var grid = $('[data-bjj-grid]', root);
    if (!grid) return;
    var cards = $$('[data-bjj-card]', grid);
    var shown = 0;
    cards.forEach(function (c) {
      var cc = (c.getAttribute('data-cat') || '').toLowerCase();
      var cs = (c.getAttribute('data-stage') || '').toLowerCase();
      var ok = (cat === 'all' || cc.split(' ').indexOf(cat) > -1) &&
               (stage === 'any' || cs.split(' ').indexOf(stage) > -1);
      c.hidden = !ok;
      if (ok) shown++;
    });
    if (sort !== 'featured') {
      var live = cards.filter(function (c) { return !c.hidden; });
      live.sort(function (a, b) {
        var pa = parseFloat(a.getAttribute('data-price')) || 0;
        var pb = parseFloat(b.getAttribute('data-price')) || 0;
        if (sort === 'price-asc') return pa - pb;
        if (sort === 'price-desc') return pb - pa;
        if (sort === 'title') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        return 0;
      });
      live.forEach(function (c) { grid.appendChild(c); });
    }
    var count = $('[data-bjj-count]', root);
    if (count) count.textContent = count.getAttribute('data-template').replace('[count]', shown);
    var empty = $('[data-bjj-empty]', root);
    if (empty) empty.hidden = shown > 0;
  }

  d.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-bjj-filter]');
    if (!chip) return;
    e.preventDefault();
    var root = chip.closest('[data-bjj-shop]');
    var kind = chip.getAttribute('data-bjj-filter');
    root.setAttribute('data-' + kind, chip.getAttribute('data-value'));
    $$('[data-bjj-filter="' + kind + '"]', root).forEach(function (c) { c.classList.remove('active', 'is-active'); });
    chip.classList.add('active', 'is-active');
    applyFilters(root);
  });
  d.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bjj-sort]');
    if (!sel) return;
    var root = sel.closest('[data-bjj-shop]');
    root.setAttribute('data-sort', sel.value);
    applyFilters(root);
  });

  /* ---------------- Stage finder -------------------------------------------- */
  function initStageFinder(root) {
    var input = $('[data-bjj-birth]', root);
    if (!input || input.__wired) return;
    input.__wired = true;
    var out = $('[data-bjj-stage-out]', root);
    var stages = [];
    try { stages = JSON.parse(root.getAttribute('data-stages') || '[]'); } catch (err) { stages = []; }
    var strings = {};
    try { strings = JSON.parse(root.getAttribute('data-strings') || '{}'); } catch (err) { strings = {}; }

    function stageIndex(m) {
      if (m < 4) return 0;
      if (m < 7) return 1;
      if (m < 10) return 2;
      if (m < 13) return 3;
      if (m < 19) return 4;
      return 5;
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

    function render() {
      if (!out) return;
      var v = input.value;
      if (!v) { out.innerHTML = '<div class="bjj-sf__idle">' + esc(strings.idle || '') + '</div>'; return; }
      var parts = v.split('-').map(Number);
      var now = new Date();
      var months = (now.getFullYear() - parts[0]) * 12 + (now.getMonth() + 1 - parts[1]);
      if (months < -9 || months > 60) { out.innerHTML = '<div class="bjj-sf__idle">' + esc(strings.idle || '') + '</div>'; return; }
      if (months < 0) {
        var n = Math.abs(months);
        out.innerHTML = '<div class="bjj-sf__big">' + esc(strings.notyet || 'Not yet') + '</div>' +
          '<p class="bjj-sf__body">' + esc((strings.expecting || '').replace('[n]', n)) + '</p>';
        return;
      }
      var s = stages[stageIndex(months)] || {};
      var html = '<div class="bjj-sf__head"><span class="bjj-sf__big">' + months + '</span>' +
        '<span class="bjj-sf__meta">' + esc(months === 1 ? (strings.month_one || 'month old') : (strings.month_other || 'months old')) + ' &middot; ' + esc(s.title || '') + '</span></div>' +
        '<p class="bjj-sf__body">' + esc(s.body || '') + '</p>';
      if (s.have && s.products && s.products.length) {
        html += '<div class="bjj-sf__list">' + s.products.map(function (p) {
          return '<a class="bjj-sf__item" href="' + esc(p.url) + '"><span>' + esc(p.title) + '</span><span class="bjj-sf__price">' + esc(p.price) + '</span></a>';
        }).join('') + '</div>';
      } else {
        html += '<div class="bjj-sf__none"><p>' + esc(strings.nothing || '') + '</p></div>';
      }
      out.innerHTML = html;
    }
    input.addEventListener('change', render);
    input.addEventListener('input', render);
    render();
  }

  /* ---------------- Init ----------------------------------------------------- */
  function init() {
    headerState();
    $$('[data-bjj-shop]').forEach(applyFilters);
    $$('[data-bjj-stagefinder]').forEach(initStageFinder);
    $$('.acc__item.open .acc__body').forEach(function (b) { b.style.maxHeight = (b.scrollHeight + 40) + 'px'; });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
  d.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    $$('.acc__item.open .acc__body').forEach(function (b) { b.style.maxHeight = (b.scrollHeight + 40) + 'px'; });
  });
})();
